import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const Hero = ({ backgroundImage, title, subtitle, buttonText, buttonLink }) => {
  const handleScrollToSection = (e) => {
    // Only handle if it's a hash link
    if (buttonLink.startsWith('#')) {
      e.preventDefault();
      const targetId = buttonLink.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 120, // Increased offset to ensure headers are fully visible
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <HeroContainer backgroundImage={backgroundImage}>
      <HeroOverlay />
      <HeroContent>
        <HeroTitle>{title}</HeroTitle>
        <HeroSubtitle>{subtitle}</HeroSubtitle>
        <HeroButton 
          to={buttonLink} 
          onClick={handleScrollToSection}
        >
          <span>{buttonText}</span>
          <FaArrowRight />
        </HeroButton>
      </HeroContent>
    </HeroContainer>
  );
};

const HeroContainer = styled.div`
  position: relative;
  height: 100vh;
  min-height: 600px;
  width: 100%;
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeroOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(19, 19, 19, 0.85) 0%,
    rgba(19, 19, 19, 0.7) 50%,
    rgba(19, 19, 19, 0.9) 100%
  );
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 800px;
  padding: 0 1.5rem;
`;

const HeroTitle = styled.h1`
  color: var(--color-tertiary);
  margin-bottom: 1.5rem;
  font-size: 4rem;
  font-weight: 600;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const HeroSubtitle = styled.p`
  color: var(--color-tertiary);
  font-size: 1.2rem;
  margin-bottom: 2.5rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const HeroButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 2.5rem;
  background-color: var(--color-primary);
  color: var(--color-tertiary);
  border: none;
  border-radius: 4px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: var(--transition);
  
  &:hover {
    background-color: var(--color-secondary);
    color: var(--color-dark);
    gap: 0.8rem;
  }
  
  svg {
    font-size: 1rem;
  }
`;

export default Hero; 